import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
//Datatable Modules
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import passport from "../assets/images/passport.jpg";
import sara from "../assets/images/sara.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-bootstrap/Pagination";
import {
  PostCallWithErrorResponse,
  postWithAuthCall,
  simpleGetCall,
  getWithAuthCallWithErrorResponse,
  DeleteCallWithErrorResponse,
} from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import { ToastMsg } from "./ToastMsg";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import moment from "moment";
import { Button, InputGroup } from "react-bootstrap";

const ProfileSuggestion = () => {
  const { sidebar, userData } = useContext(AppContext);
  const [showSuggestModel, setShowSuggestModel] = useState(false);
  const handleCloseSuggestModel = () => setShowSuggestModel(false);
  const [membershipTiers, setMembershipTiers] = useState([]);
  const [planUsers, setPlanUsers] = useState([]);
  const [suggestedUsers, setSuggestedUsers] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [approvedUsers, setApprovedUsers] = useState([]);

  // The engine generates suggestions on a schedule; this page is where an admin
  // sees WHAT was sent and WHY. Manual picking is now an override, not the norm.
  const [rows, setRows] = useState([]);
  const [rowsLoading, setRowsLoading] = useState(true);
  const [sourceFilter, setSourceFilter] = useState("");
  const [running, setRunning] = useState(false);
  const [showRunConfirm, setShowRunConfirm] = useState(false);
  const [showManual, setShowManual] = useState(false);

  const loadSuggestions = () => {
    setRowsLoading(true);
    const url = sourceFilter
      ? `${ApiConfig.MATCHING_SUGGESTIONS}?source=${sourceFilter}`
      : ApiConfig.MATCHING_SUGGESTIONS;
    getWithAuthCallWithErrorResponse(url)
      .then((res) => setRows(res?.json?.data ?? []))
      .catch(() => ToastMsg("error", "Could not load suggestions"))
      .finally(() => setRowsLoading(false));
  };

  useEffect(loadSuggestions, [sourceFilter]);

  // Deliberately behind a confirmation: this inserts suggestions AND sends a
  // push notification to every member it touches.
  const runNow = () => {
    setShowRunConfirm(false);
    setRunning(true);
    PostCallWithErrorResponse(ApiConfig.MATCHING_SUGGESTIONS_RUN, "{}")
      .then((res) => {
        if (res?.json?.error) ToastMsg("error", res.json.message);
        else ToastMsg("success", res?.json?.message || "Suggestions generated");
        loadSuggestions();
      })
      .catch(() => ToastMsg("error", "Could not run the matching engine"))
      .finally(() => setRunning(false));
  };

  // NOTE: use DeleteCallWithErrorResponse, not deleteWithAuthCall — the latter
  // sends `Token <auth_token>`, but login stores the admin token under "Token"
  // and every working call sends `Bearer`, so it would always 401.
  const removeSuggestion = (id) => {
    DeleteCallWithErrorResponse(`${ApiConfig.MATCHING_SUGGESTIONS}/${id}`)
      .then((res) => {
        if (res?.error) {
          ToastMsg("error", res?.json?.message || "Could not remove suggestion");
          return;
        }
        ToastMsg("success", "Suggestion removed");
        setRows((r) => r.filter((x) => x._id !== id));
      })
      .catch(() => ToastMsg("error", "Could not remove suggestion"));
  };

  const handleSearch = (query) => {
    setIsLoading(true);

    simpleGetCall(
      `${ApiConfig.GET_SUBSCRIPTION_PLAN_MEMBERS}/${selectedPlan}?name=${query}`
    )
      .then((response) => {
        if (response.data) setPlanUsers(response?.data);
        setIsLoading(false);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (selectedPlan)
      simpleGetCall(
        `${ApiConfig.GET_SUBSCRIPTION_PLAN_MEMBERS}/${selectedPlan}`
      )
        .then((response) => {
          if (response.data) setPlanUsers(response?.data);
        })
        .catch((error) => {});
  }, [selectedPlan]);

  useEffect(() => {
    if (selectedUser) {
      simpleGetCall(
        `${ApiConfig.GET_UNIQUE_USER_BY_USERID}/${selectedUser.subscriptionUserId}`
      )
        .then((response) => {
          if (response.data) setSuggestedUsers(response?.data);
        })
        .catch((error) => {});
    }
  }, [selectedUser]);

  //Plan Array//

  useEffect(() => {
    simpleGetCall(ApiConfig.GET_ALL_SUBSCRIPTION_PLANS)
      .then((res) => {
        console.log("GET_ALL_SUBSCRIPTION_PLANS", res.data);
        setMembershipTiers(res.data?.plans ?? []);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const isUserSuggested = (userId) => {
    return approvedUsers.some((user) => user._id === userId);
  };

  const persistSuggestedList = () => {
    const payload = {
      suggestedUsers: approvedUsers.map((u) => u._id),
      plan: selectedPlan,
      subscription: selectedUser.subscriptionId,
      user: selectedUser.subscriptionUserId,
    };
    postWithAuthCall(
      `${ApiConfig.PERSIST_SUGGESTED_USERS_PREMIUM}`,
      JSON.stringify(payload)
    )
      .then((response) => {
        if (response) {
          if (response.error) {
            ToastMsg("error", response.message);
          } else {
            ToastMsg("success", response.message);
          }
          handleCloseSuggestModel();
        }
      })
      .catch((error) => {
        console.log(error);
        handleCloseSuggestModel();
        ToastMsg("error", error.message);
      });
  };
  console.log("render", {
    membershipTiers,
    selectedPlan,
    planUsers,
    selectedUser,
    suggestedUsers,
  });
  const filterBy = () => true;
  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">Profile Suggestions</label>
        </div>

        <div className="add-btn d-flex">
          <Link
            to="/MatchingControlCenter"
            className="btn btn-outline-secondary me-2"
          >
            Matching rules
          </Link>
          <button onClick={() => setShowRunConfirm(true)} disabled={running}>
            {running ? "Running…" : "Run now"}
          </button>
        </div>
      </div>

      <p className="text-muted small">
        The matching engine generates these automatically on a schedule — nobody
        has to pick profiles by hand. Every row shows the score that earned it a
        place and why. Change the rules under{" "}
        <Link to="/MatchingControlCenter">Matching rules</Link>.
      </p>

      {/* ---- Run now: sends real push notifications, so confirm first ---- */}
      <Modal
        show={showRunConfirm}
        onHide={() => setShowRunConfirm(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Run the matching engine now?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">
              This generates suggestions for every eligible member and{" "}
              <strong>sends them a push notification</strong>. It normally runs
              on a schedule — only run it manually if you mean to.
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="buttons-modal">
            <button className="btn bg-success text-white me-2" onClick={runNow}>
              Yes, run it
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => setShowRunConfirm(false)}
            >
              Cancel
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* ---- What the engine has sent (the audit view) ---- */}
      <div className="documents-wrapper">
        <div className="search-wrapper row align-items-end">
          <Form.Group className="col-md-3">
            <Form.Label className="label-select">Source</Form.Label>
            <Form.Select
              value={sourceFilter}
              onChange={(e) => setSourceFilter(e.target.value)}
            >
              <option value="">All suggestions</option>
              <option value="AI">Generated by the engine</option>
              <option value="ADMIN">Added by an admin</option>
            </Form.Select>
          </Form.Group>
          <div className="col-md-3">
            <button
              className="btn btn-outline-secondary"
              onClick={loadSuggestions}
            >
              Refresh
            </button>
          </div>
        </div>

        <Table responsive className="mt-3">
          <thead>
            <tr>
              <th>Member</th>
              <th>Suggested profile</th>
              <th>Score</th>
              <th>Why</th>
              <th>Source</th>
              <th>Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rowsLoading ? (
              <tr>
                <td colSpan="7" className="text-center text-muted py-4">
                  Loading…
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center text-muted py-4">
                  No suggestions yet. They are generated on a schedule — or press
                  “Run now”.
                </td>
              </tr>
            ) : (
              rows.map((row) => (
                <tr key={row._id}>
                  <td>{row.user?.fullName || "—"}</td>
                  <td>{row.suggestedUser?.fullName || "—"}</td>
                  <td>
                    {typeof row.score === "number" ? (
                      <span className="badge bg-primary">{row.score}%</span>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td className="small text-muted">{row.reason || "—"}</td>
                  <td>
                    {row.source === "AI" ? (
                      <span className="badge bg-info text-dark">Engine</span>
                    ) : (
                      <span className="badge bg-secondary">
                        {row.suggestedBy?.username || "Admin"}
                      </span>
                    )}
                  </td>
                  <td className="small">
                    {row.createdAt
                      ? moment(row.createdAt).format("DD MMM YYYY, HH:mm")
                      : "—"}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => removeSuggestion(row._id)}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      <Modal
        show={showSuggestModel}
        onHide={handleCloseSuggestModel}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">
              Are you sure you want to Suggest following users to{" "}
              {selectedUser?.fullName}?
            </label>

            <ol className="mt-3 text-start overflow-auto cx-vh50 pe-4">
              {approvedUsers.map((user, index) => (
                <li key={`approved-users-${index}`}>
                  <InputGroup className="mb-3">
                    <Form.Control
                      placeholder="Recipient's username"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                      readOnly
                      value={user.fullName}
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={() => {
                        setApprovedUsers((prevState) => {
                          return prevState.filter((u) => u._id !== user._id);
                        });
                      }}
                    >
                      Remove
                    </Button>
                  </InputGroup>
                </li>
              ))}
            </ol>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal    ">
            <button className="me-2 bg-danger" onClick={persistSuggestedList}>
              Yes
            </button>
            <Link to="#" className="" onClick={handleCloseSuggestModel}>
              No
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
      {/* ======================= END DELETE ========================== */}

      {/* ---- Manual override. Kept for the rare case an admin wants to place a
              specific profile in front of a member, but it is no longer the way
              suggestions are normally made. ---- */}
      <div className="documents-wrapper mt-3">
        <button
          className="btn btn-outline-secondary"
          onClick={() => setShowManual((v) => !v)}
        >
          {showManual ? "Hide manual suggestion" : "Suggest manually (override)"}
        </button>
      </div>

      <div
        className="documents-wrapper mt-3"
        style={{ display: showManual ? "block" : "none" }}
      >
        <div className="search-wrapper row">
          <Form.Group className=" col-md-4" controlId="formBasicEmail">
            <Form.Label className="label-select">Select Plan</Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => {
                setSelectedPlan(e.target.value);
              }}
            >
              {membershipTiers.length > 0 &&
                membershipTiers.map((plan) => {
                  return <option value={plan.title}>{plan.title}</option>;
                })}
            </Form.Select>
          </Form.Group>
          <Form.Group className=" col-md-4" controlId="formBasicEmail">
            <Form.Label className="label-select">Select User</Form.Label>
            <AsyncTypeahead
              filterBy={filterBy}
              id="async-example"
              isLoading={isLoading}
              disabled={!selectedPlan}
              labelKey="subscriptionUser"
              useCache={false}
              onSearch={handleSearch}
              minLength={0}
              options={planUsers}
              placeholder="Type name to search users"
              onChange={(users) => {
                setSelectedUser(users[0]);
              }}
              renderMenuItemChildren={(option) => (
                <>
                  <span>{option.subscriptionUser}</span>
                </>
              )}
            />
          </Form.Group>
          <div className="buttons-wrapper mt-auto col-md-4">
            <button
              className={`btn ${
                approvedUsers.length === 0 ? "bg-gradient" : "bg-success"
              } text-white me-2`}
              disabled={approvedUsers.length === 0}
              onClick={() => setShowSuggestModel(true)}
            >
              Suggest Selected Users
            </button>
          </div>
        </div>
        <hr />
        <div className="row g-3 inner-wrapper">
          {suggestedUsers.length > 0 &&
            suggestedUsers.map((user) => {
              return (
                <div className="col-lg-3">
                  <div className="document-cards">
                    <div className="img">
                      <img
                        src={!user.photo_path ? sara : user.photo_path}
                        alt=""
                      />
                    </div>
                    <div className="profile-suggest-card-wrapper">
                      <label htmlFor="" className="name">
                        {user.fullName} ,
                      </label>
                      <label htmlFor="" className="age">
                        {`${moment().diff(
                          moment(user.dateOfBirth),
                          "years"
                        )} Years`}
                      </label>
                      <div>
                        <div className="heights">{user.height}"</div>
                        <div className="heights">
                          {user?.employee?.jobTitle}
                        </div>
                        <div className="heights">
                          {user?.employee?.location}
                        </div>
                      </div>
                    </div>
                    <div className="buttons-wrapper mt-3">
                      <button
                        className={`btn ${
                          !isUserSuggested(user._id)
                            ? "bg-success"
                            : "bg-danger"
                        } text-white me-2`}
                        onClick={(e) => {
                          if (!isUserSuggested(user._id)) {
                            setApprovedUsers((prevState) => [
                              ...prevState,
                              user,
                            ]);
                          } else {
                            setApprovedUsers((prevState) => {
                              return prevState.filter(
                                (u) => u._id !== user._id
                              );
                            });
                          }
                        }}
                      >
                        {!isUserSuggested(user._id) ? "Suggest" : "Remove"}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </main>
  );
};

export default ProfileSuggestion;
